import { memo } from 'react';

import { MASK } from '../../../shared/utils/mask';

interface StatCardProps {
  title: string;
  value: string | number;
  icon: string;
  suffix?: string;
  loading?: boolean;
  /** Hide mode: renders the value as a mask instead of the figure. */
  hidden?: boolean;
}

export const StatCard = memo(function StatCard({
  title,
  value,
  icon,
  suffix,
  loading,
  hidden = false,
}: StatCardProps) {
  const shown = hidden ? MASK : value;
  return (
    <div className="stat-card">
      <div className="stat-card-icon" aria-hidden="true">
        <span className="material-symbols-outlined">{icon}</span>
      </div>
      <div className="stat-card-content">
        <p className="stat-card-title">{title}</p>
        {loading ? (
          <div className="skeleton stat-card-value-skeleton" aria-busy="true" />
        ) : (
          /* tabular-nums for consistent number width */
          <p className="stat-card-value" style={{ fontVariantNumeric: 'tabular-nums' }}>
            {shown}
            {suffix && <span className="stat-card-suffix">{suffix}</span>}
          </p>
        )}
      </div>
    </div>
  );
});

export default StatCard;
